import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { LibrariesModule } from '../../libraries/libraries.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { LoginModalModule } from '../login-modal/login-modal.module';
import { RegisterModalModule } from '../register-modal/register-modal.module';
import { TruncateHTMLPipe } from '../../../common/pipes/truncate-html.pipe';


@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    LibrariesModule,
    RouterModule,
    SharedModule,
    LoginModalModule,
    RegisterModalModule,
    TruncateHTMLPipe
  ],
  exports:[HeaderComponent]
})
export class HeaderModule { }
